import { type FC, type ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';
import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { Stack } from '@mui/material';

import { VerticalLayout } from 'components/VerticalLayout/VerticalLayout';

interface LayoutProps {
  children?: ReactNode;
}

export const Layout: FC<LayoutProps> = (props) => {
  return (
    <>
      <SignedIn>
        <VerticalLayout {...props} />
      </SignedIn>
      <SignedOut>
        <Stack
          justifyItems="center"
          sx={{
            margin: 'auto',
          }}
        >
          <SignIn />
        </Stack>
      </SignedOut>
      <ToastContainer />
    </>
  );
};
